import React, {useCallback} from "react"
import {Button} from "devextreme-react/button"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsToCircle} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react"
import {dogFixPrice} from "../../api/request";
import {Buffer} from "buffer";
import notify from "devextreme/ui/notify";
import LoadPanel from "devextreme-react/load-panel";
import {useReqPopup} from "../../contexts/req-popup";

const FixPricePage = () => {
    const [loading, setLoading] = useState(false)
    const { openReqPopup } = useReqPopup()
    const onDownloadBtnClick = useCallback(async() => {
        setLoading(true)
        try {
            const res = await dogFixPrice()
            if (res.isOk) { //если успешно создали заявку
                const file = res.data.file;
                const filename = res.data.file_name;
                let fileDownload = require('js-file-download');
                fileDownload(Buffer.from(file), filename);
            } else {
                notify(res.message, 'error', 5000);
            }
        } catch (e) {
            notify(e.message, 'error', 5000);
        } finally {
            setLoading(false)
        }
    },[])


    return (
        <div className={'content-block dx-card responsive-paddings big-input'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faArrowsToCircle} />
            <h3><strong>Фиксированная цена{/*<ZagolovokFromMenu/>*/}</strong></h3>
            <LoadPanel visible={loading} />
            <h4 className='mt-4'>Что такое фиксированная цена?</h4>
            <p>Фиксированная цена - это тариф на электроэнергию, который не меняется в течение определённого периода времени. Это означает, что вы платите одну и ту же сумму за каждый киловатт-час электроэнергии, независимо от колебаний цен на рынке.</p>
                <p>Фиксированная цена создаёт определённость при планировании бюджета в условиях нестабильной экономической ситуации. С этой услугой Вы сможете быть уверены в том, что стоимость электроэнергии останется неизменной на протяжении всего срока действия договора. Это позволит Вам избежать неожиданных скачков тарифов и спланировать свои расходы заранее.</p>
                <div>
                    <Button className='mt-3 mr-4' type={'default'} text="Скачать бланк заявления" icon='download' onClick={onDownloadBtnClick}></Button>
                    <Button
                        icon='plus'
                        type='default'
                        text='Новое обращение'
                        onClick={() => {openReqPopup(true,23);}}
                        className={'mt-3'}
                    />
                </div>
        </div>
    )
}

export default FixPricePage
